import type { Project } from 'types/api.types';
import type { DataNode } from 'antd/lib/tree';

export interface NodeProps extends DataNode {
  children?: NodeProps[];
  'data-e2e'?: string;
}

type MapProjectsOptions = {
  rootTitle?: string;
  withRoot?: boolean;
  disabledProjects?: string[];
  disabled?: boolean;
};

export const ROOT_KEY = '-root-';

export const mapProjectsToAntdTreeNodes = (
  rootProjects: Project[],
  { rootTitle, withRoot, disabledProjects, disabled }: MapProjectsOptions
): NodeProps[] => {
  const disabledProjectsSet = new Set(disabledProjects);
  const mapper = (
    projects: undefined | Project[],
    disabledProjects?: Set<string>,
    disabled?: boolean
  ): NodeProps[] | undefined => {
    return projects?.map(project => {
      const isDisabled = Boolean(disabled || disabledProjects?.has(project.id));
      return {
        title: project.name,
        key: project.id,
        value: project.id,
        'data-e2e': `project-tree-node-${project.name}`,
        disabled: isDisabled,
        ...(project.children ? { children: mapper(project.children, disabledProjects, disabled) } : undefined)
      };
    });
  };
  const tree = mapper(rootProjects, disabledProjectsSet, disabled);
  return !withRoot
    ? tree!
    : [
        {
          title: rootTitle,
          key: ROOT_KEY,
          'data-e2e': 'project-tree-node-root',
          children: tree
        }
      ];
};
